// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-field .v-input__control .v-input__slot{max-height:39px!important;min-height:39px!important}.custom-html *{color:#00a65a!important;margin:0!important;padding:0!important}", ""]);
// Exports
module.exports = exports;
